import { useCallback, useEffect, useRef, useState } from "react";
import { api, errMsg } from "@/lib/api";

// Fetch a URL and refresh periodically (near real-time sync between devices).
export default function usePoll(url, params, interval = 15000) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const key = JSON.stringify(params || {});
  const alive = useRef(true);

  const load = useCallback(async () => {
    if (!url) return;
    try {
      const r = await api.get(url, { params: JSON.parse(key) });
      if (alive.current) { setData(r.data); setError(null); }
    } catch (e) {
      if (alive.current) setError(errMsg(e));
    } finally {
      if (alive.current) setLoading(false);
    }
  }, [url, key]);

  useEffect(() => {
    alive.current = true;
    setLoading(true);
    load();
    if (!interval) return () => { alive.current = false; };
    const t = setInterval(() => { if (!document.hidden) load(); }, interval);
    return () => { alive.current = false; clearInterval(t); };
  }, [load, interval]);

  return { data, error, loading, reload: load };
}
